'use client';
import { styled } from '@mui/material/styles';
export const AlertContent = styled('div') `
    flex-grow: 1;
`;
